import React, { useState, useRef, useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { CancelToken } from "axios";
import { message } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { ReactComponent as AttachmentIcon } from "../../../images/chat/paper-clip.svg";
import TimeShower from "../../../components/TimeShower";
import { addNewMessage, messageUpdateStatus } from "../../../actions/message";
import TextInput from "./TextInput";
import VoiceInput from "./VoiceInput";
import {
  MessageServerConstant,
  MessageStatus,
  MessageType,
  SessionStatus,
} from "../../../constant/Types";
import {
  sendMessagePWAService as sendMessagePWAConsultitionService,
  sendMessageService as sendMessageConsultitionService,
} from "../chat.api";
import { sendMessageServiceVersion2 as sendMessageTicketServiceVersion2 } from "../../supports/support.api";
import AttachmentInput from "./AttachmentInput";
import {
  b64toBlob,
  checkValue,
  errorMessageHandler,
  getImageSize,
  objectToFormData,
  toBase64,
} from "../../../constant/helper";
// import moment from "moment-jalaali";
import jsPDF from "jspdf";
import { ChatLoadingContext } from "../ChatLoadingContextProvider";
import { InReplyContext } from "../Chat";
import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd/lib";

export const SendType = {
  free: "free",
  text: "text",
  file: {
    select: "select",
    upload: "upload",
    cancel: "cancel",
    send: "send",
  },
  voice: {
    recoding: "voice-recoding", // start
    hold: "voice-hold",
    fixed: "voice-fixed", // open popup
    send: "voice-send",
    cancel: "voice-cancel",
  },
};

const Footer = ({
  popup,
  showPopup,
  ticketDetail,
  sessionDetail,
  isTicket,
  ticketId,
  isBaseOnTime = false,
  openLawyerRate,
  getMessages,
  sessionId,
  scrollToBottom,
  closeTopSheet,
  messagesList,
  rootType,
}) => {
  const dispatch = useDispatch();
  const [sendType, setSendType] = useState(SendType.free);
  const [voiceTime, setVoiceTime] = useState(0);
  const { inReply, setInReply } = useContext(InReplyContext);
  const [msg, setMsg] = useState("");
  const [focus, setFocus] = useState();
  const inputRef = useRef();
  const { setAllChatLoading } = useContext(ChatLoadingContext);

  useEffect(() => {
    if (inReply && focus) {
      focus.focus();
      focus.select();
    }
  }, [focus, inReply]);
  function handleCloseReply() {
    setInReply();
  }

  async function sendMessage(messageTypes, messageData, messageMetaData) {
    setSendType(SendType.free);

    let cancel;
    let cancelToken = new CancelToken((c) => {
      cancel = c;
    });
    if (cancel && messageMetaData) {
      messageMetaData.cancelToken = cancel;
    }

    let messageServerType = MessageServerConstant.text;
    let name = "";

    if (messageTypes === MessageType.client.media) {
      messageServerType = messageMetaData.messageType;

      if (messageServerType === "IMAGE") {
        // convert image to pdf

        name = messageData.name;
        name = name.split(".");
        name.pop();
        name.join(".");
        name += ".pdf";

        messageData = new File([messageData], name, {
          type: messageData.type,
        });
      }
    }

    const { data } = dispatch(
      addNewMessage(
        messageTypes,
        {
          ...messageData,
          inReplyToTheMessage: inReply?.text
            ? { text: inReply.text }
            : undefined,
        },
        messageMetaData
      )
    );

    let params = {
      text: data.data.text,
      clientMessageId: data.id,
    };

    if (messageTypes === MessageType.client.voice) {
      setAllChatLoading(true);

      messageServerType = MessageServerConstant.voice;
      params = {
        clientMessageId: data.id,
        file: messageData,
        voiceDuration: messageMetaData.duration ? messageMetaData.duration : 0,
      };
    }

    if (messageTypes === MessageType.client.media) {
      setAllChatLoading(true);

      messageServerType = messageMetaData.messageType;
      params = {
        clientMessageId: data.id,
        file: messageData,
      };

      if (messageServerType === "IMAGE") {
        // convert image to pdf
        const img = await toBase64(messageData);
        const imgSize = await getImageSize(img);
        const doc = new jsPDF("p", "px", "a4");
        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();

        const widthRatio = width / imgSize.width;
        const heightRatio = height / imgSize.height;
        const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;
        const canvasWidth = imgSize.width * ratio;
        const canvasHeight = imgSize.height * ratio;
        const marginX = (width - canvasWidth) / 2;
        const marginY = (height - canvasHeight) / 2;

        doc.addImage(
          img,
          "JPEG",
          marginX,
          marginY,
          canvasWidth,
          canvasHeight,
          undefined,
          "MEDIUM"
        );
        params.file = doc.output("blob");
        params.file.name = name;
        messageServerType = "DOCUMENT";
      }
    }

    if (inReply) {
      params.inReplyToTheMessageId = inReply.messageId;
    }
    setInReply();
    sendMessageService(messageTypes, sessionId, messageServerType, params, {
      cancelToken,
      msgId: data.id,
    })
      .then((resp) => {
        let clientMessageId = resp.config.msgId;
        dispatch(
          messageUpdateStatus(
            resp.data.id,
            clientMessageId,
            MessageStatus.ready,
            null,
            `data:audio/mp3;base64,${messageData}`,
            resp.data.fileId
          )
        );
        getMessages();
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          err.response.config &&
          err.response.config.msgId
        ) {
          if (err.response.status === 412) {
            message.error(
              err?.response?.data?.message
                ? err.response.data.message
                : "نیاز به شارژ دوباره دارید"
            );
          }
          const msgId = err.response.config.msgId;
          dispatch(messageUpdateStatus(msgId, msgId, MessageStatus.failed));
        } else {
          message.error(errorMessageHandler(err));
        }
      })
      .finally(() => {
        // setAllChatLoading(false);
        setTimeout(function () {
          scrollToBottom();
        }, 1000);
      });
  }

  function sendMessageService(
    messageType,
    sessionId,
    messageServerType,
    params,
    extra
  ) {
    if (!isTicket) {
      if (messageType === MessageType.client.voice) {
        return sendMessagePWAConsultitionService(
          sessionId,
          messageServerType,
          params,
          extra
        );
      } else {
        return sendMessageConsultitionService(
          sessionId,
          messageServerType,
          params,
          extra
        );
      }
    } else {
      if (
        messageType === MessageType.client.voice ||
        messageType === MessageType.client.media ||
        messageType === MessageType.client.image
      ) {
        const soundBlob = b64toBlob(params.file, "audio/mpeg"); // backend needs formdata (binary) so ....
        const formData = new FormData();
        formData.append("file", soundBlob);

        return sendMessageTicketServiceVersion2(formData, ticketId);
      } else {
        return sendMessageTicketServiceVersion2(
          objectToFormData({
            content: params.text,
          }),
          ticketId
        );
      }
    }
  }

  // file attachment
  function openAttachmentPopup() {
    setSendType(SendType.file.select);
  }

  function handleSubmitText() {
    inputRef.current.submit();
  }

  const isChatDisabled =
    sessionDetail.sessionStatus === SessionStatus.CLOSED ||
    sessionDetail.sessionStatus === SessionStatus.CLOSED_BY_ADMIN;

  return (
    <>
      {isTicket &&
      ticketDetail &&
      ticketDetail.state.current.state === SessionStatus.CLOSED ? (
        ""
      ) : (sessionDetail.sessionStatus === SessionStatus.CLOSED ||
          sessionDetail.sessionStatus === SessionStatus.CLOSED_BY_ADMIN) &&
        checkValue(sessionDetail.rate) ? (
        <div className={"chat-footer-overlay"}>
          {/* <p className="description">
            این جلسه مشاوره توسط مشاور یا ادمین بسته شده است و امکان ارسال پیام
            وجود ندارد!
          </p>  */}
          <p className="description">
            امکان ارسال پیام به دلیل بسته شدن جلسه مشاوره وجود ندارد
          </p>
        </div>
      ) : isBaseOnTime &&
        checkValue(sessionDetail.battery) &&
        sessionDetail.sessionStatus === SessionStatus.STARTED &&
        sessionDetail.battery.hasOwnProperty("allowedForTyping") &&
        !sessionDetail.battery.allowedForTyping ? (
        <div className={"chat-footer-overlay"}>
          <p>
            این جلسه مشاوره یکطرفه شده است و فقط وکیل میتواند پیام ارسال کند
          </p>
        </div>
      ) : (
        <div className={"chat-footer"}>
          {showPopup && popup}
          <div
            className={`chat-box-wrapper ${
              isChatDisabled ? "chat-disabled-rate" : ""
            }`}
          >
            {inReply && (
              <div className="in-reply">
                <Button
                  onClick={handleCloseReply}
                  className="close-btn"
                  type="text"
                >
                  <CloseOutlined />
                </Button>
                <div className="text">{inReply.text}</div>
              </div>
            )}
            <AttachmentInput
              sendType={sendType}
              rootType={rootType}
              setSendType={setSendType}
              limitedFileCount={6}
              sendMessage={sendMessage}
            />

            <div className="chat-box-holder center-flex">
              <div
                className={`chat-input-holder ${
                  sendType === SendType.voice.recoding
                    ? "voice-recording center-flex"
                    : ""
                }`}
              >
                {(sendType === SendType.free || sendType === SendType.text) && (
                  <TextInput
                    ref={inputRef}
                    sendMessage={sendMessage}
                    sendType={sendType}
                    setSendType={setSendType}
                    onFocus={(e) => {
                      closeTopSheet && closeTopSheet();
                    }}
                    {...{ msg, setMsg, setFocus }}
                  />
                )}

                {sendType === SendType.voice.recoding && (
                  <div className={`record-time unselectable`}>
                    <TimeShower time={voiceTime ? voiceTime : 0} />
                  </div>
                )}
              </div>
              <div className="buttons-holder unselectable">
                {sendType === SendType.text || msg.length > 0 ? (
                  <IconBtn
                    className={"btn-send-input test"}
                    icon={<SendOutlined />}
                    onClick={handleSubmitText}
                  />
                ) : (
                  <VoiceInput
                    voiceTime={voiceTime}
                    setVoiceTime={setVoiceTime}
                    setSendType={setSendType}
                    sendType={sendType}
                    sendMessage={sendMessage}
                  />
                )}
                {(sendType === SendType.free || sendType === SendType.text) &&
                  !isTicket && (
                    <IconBtn
                      className={"btn-attachment test"}
                      icon={<AttachmentIcon />}
                      onClick={openAttachmentPopup}
                    />
                  )}

                {sendType === SendType.voice.recoding && !isTicket && (
                  <IconBtn className={"btn-attachment bg-white"} />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const IconBtn = ({ icon, className = "", ...props }) => {
  return (
    <div className={`center-flex ${className}`} {...props}>
      {icon && icon}
    </div>
  );
};

export default Footer;
